import React from 'react'
import { Table } from 'rsuite'

export default function AssetHistoryTable({ datas, loading }) {
  const { Column, HeaderCell, Cell } = Table

  return (
    <>
      <Table
        wordWrap
        minHeight={350}
        autoHeight
        //height={tableData.length < 10 ? undefined : 700}
        //autoHeight={tableData.length < 10}
        loading={loading}
        data={datas || []}
        affixHeader
      >
        <Column width={80} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={250} align="center">
          <HeaderCell>วันที่ดำเนินการ</HeaderCell>
          <Cell dataKey="date" />
        </Column>
        <Column width={220}>
          <HeaderCell>ผู้ดำเนินการ</HeaderCell>
          <Cell dataKey="actioner" />
        </Column>
        <Column width={230} align="center">
          <HeaderCell>สถานะ</HeaderCell>
          <Cell dataKey="status" />
        </Column>
        <Column width={250} minWidth={250} flexGrow={1}>
          <HeaderCell>ความคิดเห็น/หมายเหตุ</HeaderCell>
          <Cell dataKey="note" />
        </Column>
      </Table>
    </>
  )
}
